import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';

export const ProtectedRoute = () => {
    const { user, loading: authLoading } = useAuth();

    // Still loading auth
    if (authLoading) {
        return <LoadingSpinner />;
    }

    // Not authenticated
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // All good - render protected content
    return <Outlet />;
};


